import { type ReactNode, useId, useState } from "react";

import { Disclosure, DisclosureChevron } from "./panel";

/** Bloc repliable d'une fiche ou d'un document (« Définitions UE et UF », sections d'un ordre reçu) : ligne de
 *  titre de 32 px sur toute la largeur, chevron à gauche qui pivote, contenu déplié en hauteur et en fondu
 *  (`Disclosure`, durée `--gx-enter`, fondu seul en mouvement réduit). Filet en bas, sauf le dernier. */
export function Collapsible({
  title,
  trailing,
  defaultOpen = false,
  children,
}: {
  title: ReactNode;
  trailing?: ReactNode;
  defaultOpen?: boolean;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);
  const id = useId();
  return (
    <div className="border-b border-line last:border-b-0">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        aria-controls={id}
        className="flex min-h-8 w-full items-center gap-2 px-4 py-1.5 text-left transition-colors hover:bg-hover/60"
      >
        <DisclosureChevron open={open} />
        <span className="min-w-0 flex-1 text-ui leading-snug font-medium break-words text-ink">{title}</span>
        {trailing}
      </button>
      <Disclosure open={open} id={id}>
        <div className="px-4 pt-1 pb-4">{children}</div>
      </Disclosure>
    </div>
  );
}
